import { useEffect, useState } from 'react';

import { useLocation, useSearchParams } from 'react-router-dom';

import GMPList from './GMPList/GMPList';

type GMPProps = {
  section: 'messages' | 'chronicles' | 'shards';
};

const GMP = ({ section: initialSection }: GMPProps) => {
  const [currentSection, setCurrentSection] = useState(initialSection);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Update section when route or URL params change
  useEffect(() => {
    const sectionFromUrl = searchParams.get('section');
    if (sectionFromUrl === 'chronicles' || sectionFromUrl === 'shards') {
      setCurrentSection(sectionFromUrl);
    } else if (location.pathname.includes('/chronicles')) {
      setCurrentSection('chronicles');
    } else if (location.pathname.includes('/shards')) {
      setCurrentSection('shards');
    } else {
      setCurrentSection('messages');
    }
  }, [location.pathname, searchParams]);

  const handleSectionChange = (newSection: 'messages' | 'chronicles' | 'shards') => {
    setCurrentSection(newSection);
  };

  return <GMPList section={currentSection} onSectionChange={handleSectionChange} />;
};

export default GMP;
